import { apiClient } from './client';

/**
 * 조직 일괄등록 — 부서·팀을 CSV 로 한 번에 (2026-08-30 · 판 B3).
 *
 * ★ 사용자 일괄등록은 있는데 **조직은 없었다** — 회사를 처음 세울 때 부서·팀을 하나씩 손으로
 *   만들어야 했다.
 */

export interface OrgImportRowError {
  row: number;
  code: string;
  message: string;
}

export interface OrgImportResult {
  totalRows: number;
  divisionsCreated: number;
  teamsCreated: number;
  leadersSet: number;
  /** 이미 있어서 안 만든 것 — 「아무 일도 안 일어났다」와 구별해서 보여 준다. */
  skipped: number;
  errors: OrgImportRowError[];
}

export async function importOrgCsv(file: File): Promise<OrgImportResult> {
  const form = new FormData();
  form.append('file', file);
  const { data } = await apiClient.post('/hr/org/bulk-import', form);
  return data;
}
